import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureKeys } from '../app.reducer';
import { CorporateDashboardState } from './corporate-dashboard.reducer';

export const selectCorporateDashboardFeature = createFeatureSelector<CorporateDashboardState>(
  FeatureKeys.CORPORATE_DASHBOARD
);

export const selectCorporateDashboardQuery = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.query
);

export const selectCorporateDashboardAppointments = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.appointments
);

export const selectCorporateDashboardLoading = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.loading
);

export const selectCorporateDashboardLoaded = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.loaded
);

export const selectCorporateDashboardError = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.error
);

export const selectDashboardCounts = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.dashboardCounts
);

export const selectDashboardCountsLoading = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.countsLoading
);

export const selectDashboardCountsLoaded = createSelector(
  selectCorporateDashboardFeature,
  (state: CorporateDashboardState) => state.countsLoaded
);
